import React from "react";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const CopyableListInput = ({ label, title,dir }) => {
  // Function to copy text to clipboard
  const { t } = useTranslation();

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert(`${t("Copied")} ${text}`);
  };

  return (
    <div className="md:w-[80%] w-full" >
      <div className="w-full mb-4 text-lg font-bold text-black">{label}</div>
      <div className="flex items-center justify-between w-full gap-4 mb-4 bg-white border border-gray-500">
        {/* Title on the right */}
        <h2 className="flex-grow p-2 text-black bg-white rounded-md ">{title}</h2>

        {/* Copy Button */}
        <button
          onClick={() => copyToClipboard(title)} // Copy the `title` prop
          className="p-2 text-gray-600 bg-white rounded-md hover:text-black"
          // dir="ltr"
        >
          <ClipboardDocumentIcon className="w-5 h-5 text-gray-600 hover:text-black" />
        </button>
      </div>
    </div>
  );
};

export default CopyableListInput;
